import Axios from "api/axios"
import qs from "query-string"

import { history } from 'app-history'

export const getListingApplicants = async () => {
  const params = qs.parse(history.location.search)

  if (!params.jobId) history.push('/app/joblist')

  try {
    const result = await Axios({
      withCredentials: true,
      method: 'GET',
      url: '/listings/applicants',
      params
    })
    return result.data
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}

export const getListingFilteredApplicants = async (data) => {
  const params = qs.parse(history.location.search)

  const keywords = data.map((item) => item.value)

  if (!params.jobId) history.push('/app/joblist')

  try {
    const result = await Axios({
      withCredentials: true,
      method: 'POST',
      url: '/listings/applicants',
      params,
      data: { keywords }
    })
    return result.data
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}

export const updateApplicantFlag = async (data) => {
  const params = qs.parse(history.location.search)

  if (!params.jobId) history.push('/app/joblist')

  try {
    const result = await Axios({
      withCredentials: true,
      method: 'PATCH',
      url: '/listings/applicants/flag',
      data: {
        listingId: params.jobId,
        ...data
      }
    })
    return result.data
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}

export const updateApplicantReferenceTrigger = async (data) => {
  const params = qs.parse(history.location.search)

  if (!params.jobId) history.push('/app/joblist')

  try {
    const result = await Axios({
      withCredentials: true,
      method: 'PATCH',
      url: '/listings/applicants/referencetrigger',
      data: {
        listingId: params.jobId,
        ...data
      }
    })
    return result.data
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}


export const updateApplicantStatus = async (data) => {
  const params = qs.parse(history.location.search)

  if (!params.jobId) history.push('/app/joblist')

  try {
    const result = await Axios({
      withCredentials: true,
      method: 'PATCH',
      url: '/listings/applicants/status',
      data: {
        listingId: params.jobId,
        ...data
      }
    })
    return result.data
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}

export const getResume = async () => {
  const params = qs.parse(history.location.search)

  if (!params.jobId) history.push('/app/joblist')
  if (!params.applicantId) history.push('/app/joblist')

  try {
    const result = await Axios({
      withCredentials: true,
      method: 'GET',
      url: '/applicant/resume',
      params
    })
    return result.data
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}

export const getAssessment = async () => {
  const params = qs.parse(history.location.search)

  if (!params.jobId) history.push('/app/joblist')
  if (!params.applicantId) history.push('/app/joblist')
  if (!params.referenceId) history.push('/app/joblist')

  try {
    const result = await Axios({
      withCredentials: true,
      method: 'GET',
      url: '/applicant/assessment',
      params
    })
    return result.data
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}
